import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pen",
  "use": "icon-pen-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pen\">\n<path d=\"M12.8018 7.41133L16.5885 11.198L9.59446 18.192L5.30246 19.6277C4.72746 19.82 4.18013 19.2727 4.37213 18.6977L5.8078 14.4057L12.8018 7.41133ZM13.7445 6.46866L15.4891 4.724C16.0098 4.20333 16.8541 4.20333 17.3748 4.724L19.2758 6.625C19.7965 7.14566 19.7965 7.99 19.2758 8.51066L17.5311 10.2553L13.7445 6.46866Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/pen.svg
// module id = OaNg
// module chunks = 262